import { render, staticRenderFns } from "./TabelaVerificacaoTerritoriosProdutores.vue?vue&type=template&id=3f543c3c&lang=pug"
import script from "./TabelaVerificacaoTerritoriosProdutores.vue?vue&type=script&lang=js"
export * from "./TabelaVerificacaoTerritoriosProdutores.vue?vue&type=script&lang=js"
import style0 from "./TabelaVerificacaoTerritoriosProdutores.vue?vue&type=style&index=0&id=3f543c3c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports